function Cancel() {
    return (
        <h1> Sorry to see you have canceled your payment</h1>
    )

}

export default Cancel;